import type { ListFilterFieldDef } from '../types'

export const VENUE_SEARCH_FILTER_FIELD: ListFilterFieldDef = {
  key: 'venue',
  label: 'Venue',
  kind: 'text',
  placeholder: 'Venue slug or ID',
}

export const VENUE_TYPE_FILTER_FIELD: ListFilterFieldDef = {
  key: 'venueType',
  label: 'Type',
  kind: 'select',
  searchMode: 'none',
  options: [
    { value: 'ingested', label: 'Ingested' },
    { value: 'manual', label: 'Manual' },
  ],
}

export const VENUES_FILTER_FIELDS: readonly ListFilterFieldDef[] = [
  VENUE_SEARCH_FILTER_FIELD,
  VENUE_TYPE_FILTER_FIELD,
]
